import BaseLayoutView from 'app/src/views/base/BaseLayoutView';

import paymentProcessingViewTemplate from './templates/payment-processing-view.hbs';

// configure
let View = BaseLayoutView.extend({
  template: paymentProcessingViewTemplate,
});

// define
export default class PaymentProcessingLayout extends View {}
